import React, { useState } from 'react';
import {
  Text,
  Button,
  Group,
  Center,
  Modal,
  ModalBody,
  ModalHeader,
} from '@mantine/core';

const LogoutModal = ({ isopen, onConfirm, onCancel }) => {
  return (
    <Modal centered opened={isopen} onClose={onCancel} title="Logout Confirmation">
      {/* <ModalHeader>Are you sure you want to logout?</ModalHeader> */}
      <ModalBody>
        <Text className='!py-3'>Are you sure you want to logout?</Text>
      </ModalBody>

      {/* <ModalFooter> */}
        <Group position="right">
          <Button variant="subtle" onClick={onCancel}>
            Cancel
          </Button>
          <Button onClick={onConfirm}>Logout</Button>
        </Group>
      {/* </ModalFooter> */}
    </Modal>
  );
};

export default LogoutModal;